/** While a field shift is on, records this device's location every ~2 minutes (only while the CRM is open). */
import React, { useEffect, useRef, useState } from 'react';
import { Radio } from 'lucide-react';
import api from '../../lib/api';

export const FIELD_EVENT = 'field-shift-changed';
const EVERY_MS = 120000;

export function FieldTracker() {
  const [on, setOn] = useState(false);
  const [denied, setDenied] = useState(false);
  const last = useRef(0);
  useEffect(() => {
    const check = () => api.request('/field/me', { quiet: true }).then((d) => setOn(!!d.shift)).catch(() => setOn(false));
    check();
    window.addEventListener(FIELD_EVENT, check);
    return () => window.removeEventListener(FIELD_EVENT, check);
  }, []);
  useEffect(() => {
    if (!on || !navigator.geolocation) return undefined;
    const id = navigator.geolocation.watchPosition((p) => {
      setDenied(false);
      window.__fieldLastFix = { lat: p.coords.latitude, lng: p.coords.longitude, accuracy_m: p.coords.accuracy, t: Date.now() };
      if (Date.now() - last.current < EVERY_MS) return;
      last.current = Date.now();
      api.request('/field/ping', { method: 'POST', quiet: true, body: JSON.stringify({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy_m: p.coords.accuracy, at: new Date(p.timestamp).toISOString() }) })
        .then(() => window.dispatchEvent(new Event('field-ping'))).catch(() => {});
    }, () => setDenied(true), { enableHighAccuracy: true, maximumAge: 60000 });
    return () => navigator.geolocation.clearWatch(id);
  }, [on]);
  if (!on) return null;
  return (
    <span className={`hidden items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium sm:flex ${denied ? 'bg-amber-100 text-amber-800' : 'bg-emerald-100 text-emerald-800'}`} data-testid="field-tracking-indicator">
      <Radio className="h-3.5 w-3.5 animate-pulse" />{denied ? 'Location blocked — allow it in your browser' : 'Field shift on · location shared'}
    </span>
  );
}
